import { closestCenter, DndContext, DragEndEvent } from '@dnd-kit/core'
import { arrayMove, SortableContext } from '@dnd-kit/sortable'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Button } from '../components/Button'
import { PreviewBlock } from '../components/Links/previewBlock'
import { SocialIcon } from '../components/SocialIcon'
import { handleError } from '../helpers/handleError.ts'
import { AddIconsModal } from '../modals/AddIconsModal.tsx'
import { getSocialMedia, updateOrder } from '../services/socialMedia.ts'
import { updatePage } from '../services/page.ts'
import { toast } from 'react-toastify'
import { getPageInfo } from '../services/userProfile.ts'

export const Icons = () => {
  const [showModal, setShowModal] = useState(false)
  const [position, setPosition] = useState('')
  const [socialMediaIcons, setSocialMediaIcons] = useState<SocialMedia[] | []>(
    [],
  )
  const { t } = useTranslation()

  const handleAddClick = () => {
    setShowModal(true)
  }

  const onAddIcon = () => {
    console.log('added')
  }

  const handleDragEnd = async (event: DragEndEvent) => {
    const { active, over } = event
    if (!over) return

    const oldOrder = [...socialMediaIcons]
    const oldIndex = socialMediaIcons.findIndex((item) => item.id === active.id)
    const newIndex = socialMediaIcons.findIndex((item) => item.id === over.id)

    const newOrder = arrayMove(socialMediaIcons, oldIndex, newIndex)
    setSocialMediaIcons(newOrder)

    try {
      await updateOrder({ ids: newOrder.map((item) => item.id) })
    } catch (error) {
      handleError(error)

      setSocialMediaIcons(oldOrder)
    }
  }

  const updatePosition = async (value: string) => {
    await updatePage({ position: value })
      .then(() => {
        toast.success('Position updated successfully')
      })
      .catch((error) => {
        toast.success('Something went wrong!')
      })
  }

  useEffect(() => {
    getPageInfo('alshaikh').then((profile) =>
      setPosition(profile?.pages[0]?.position),
    )

    const fetchSocialMediaIcons = async () => {
      try {
        const icons: SocialMedia[] = await getSocialMedia()
        const sortedIcons = icons.sort((a, b) => a.order_id! - b.order_id!)
        setSocialMediaIcons(sortedIcons)
      } catch (e) {
        console.log(e)
      }
    }

    fetchSocialMediaIcons()
  }, [position])

  return (
    <div className="flex flex-col sm:flex-row">
      <div
        className="flex flex-col overflow-scroll px-10 pb-10 pt-5 sm:top-0 sm:ml-[100px] sm:w-[50%]"
        style={{ height: 'calc(100vh - 89px)' }}
      >
        <div className="w-full">
          <h1 className="text-left text-2xl font-medium">{t('iconTitle')}</h1>
          <p className="mb-2.5 text-sm">{t('descIcon')}</p>

          <Button
            text={t('addIcon')}
            className="mb-8 w-full text-white"
            type="button"
            onClick={handleAddClick}
          />
          <DndContext
            collisionDetection={closestCenter}
            onDragEnd={handleDragEnd}
          >
            <SortableContext items={socialMediaIcons.map(({ id }) => id)}>
              <div className="mb-6 flex flex-col gap-2.5">
                {socialMediaIcons.map(({ id, name, enabled, link }) => (
                  <SocialIcon
                    key={id}
                    id={id}
                    name={name}
                    enabled={enabled}
                    link={link}
                    setSocialMediaIcons={setSocialMediaIcons}
                  />
                ))}
              </div>
            </SortableContext>
          </DndContext>

          <div className="flex flex-row items-center justify-between gap-2">
            <div>
              <h1 className="text-left text-[18px] font-medium">
                {t('Position')}
              </h1>
              <p className="mb-2.5 text-sm">{t('iconText')}</p>
            </div>

            {position && <select
              id="position"
              name="position"
              defaultValue={position}
              className="order-themePrimary mb-5 mt-2 h-[46px] w-[140px] rounded-[10px] border
            bg-white px-2 shadow-normal outline-none focus:border-themePrimary"
              onChange={(choice) => updatePosition(choice.target.value)}
            >
              <option value={'top'}>Top</option>
              <option value={'bottom'}>Bottom</option>
            </select>}
          </div>

          <AddIconsModal
            setSocialMediaIcons={setSocialMediaIcons}
            setShowModal={setShowModal}
            showModal={showModal}
            onClose={() => setShowModal(false)}
            onConfirm={onAddIcon}
          />
        </div>
      </div>

      <div
        className="hidden w-[50%] items-center border-l border-gray-300 sm:flex"
        style={{ height: 'calc(100vh - 89px)' }}
      >
        <PreviewBlock />
      </div>
    </div>
  )
}
